/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import wrapWithProvider from './with-provider';
import Layout from './src/containers/Layout'
// import UtmRecorder from './src/containers/UtmRecorder';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return (
    <Layout {...props}>
      {element}
      {/* <UtmRecorder /> */}
    </Layout>
  )
}

if (process.env.NODE_ENV === 'development') {
  window.gtag = console.log
  window.fbq = console.log
}
